<template lang="pug">
  transition(name="fade" mode="out-in" appear)
    .PageTitle
      .PageTitle_baseline(v-if="top||bottom")
        transition(name="fade")
          p.PageTitle_baselineLabel.PageTitle_baselineLabel-top(v-if="top" ref="baselineTop" :key="top") {{ top }}
        .sep.PageTitle_baselineSep(ref="baselineSep")
        transition(name="fade")
          p.PageTitle_baselineLabel.PageTitle_baselineLabel-bottom(v-if="bottom" ref="baselineBottom" :key="bottom") {{ bottom }}

      transition
        h1.PageTitle_title(ref="title", :key="title") {{ title }}

</template>

<script>

import {TweenLite, TimelineLite} from 'gsap'

export default {
  props: ['top', 'bottom', 'title'],
  beforeDestroy () {
    // Au cas où l'animation d'apparition ne soit pas finie
    // on l'arrète et la supprime
    if (this._animTimeline) {
      this._animTimeline.kill()
      this._animTimeline = null
    }

    this.$parallax.remove(this.$el)
  },
  mounted () {
    this.$parallax.set(this.$el, { y: 0, opacity: 1 }, { y: 0, opacity: 1 }, { y: -90, opacity: 0 }, null, -0.3)
  },
  methods: {
    /**
     * Animation d'apparition
     */
    enter (pEl, pDone) {
      const timeline = new TimelineLite({onComplete: pDone})

      // title
      timeline.fromTo(this.$refs.title, 1.2, {
        y: 50,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        onComplete: () => { this.$refs.title.style = null }
      })

      if (this.$refs.baselineSep) {
        const lineWidth = this.$refs.baselineSep.getBoundingClientRect().width
        timeline.fromTo(this.$refs.baselineSep, 0.8, {
          width: 0
        }, {
          width: lineWidth,
          clearProps: 'width',
          onComplete: () => { this.$refs.baselineSep.style = null }
        }, 0.25)
      }

      if (this.$refs.baselineTop) {
        timeline.fromTo(this.$refs.baselineTop, 0.8, {
          x: -20,
          opacity: 0
        }, {
          x: 0,
          opacity: 1,
          onComplete: () => { this.$refs.baselineTop.style = null }
        }, 0.5)
      }

      if (this.$refs.baselineBottom) {
        timeline.fromTo(this.$refs.baselineBottom, 0.8, {
          x: 20,
          opacity: 0
        }, {
          x: 0,
          opacity: 1,
          onComplete: () => { this.$refs.baselineBottom.style = null }
        }, 0.55)
      }

      // On enregistre la timeline si besoin
      this._animTimeline = timeline
    }
  }
}

</script>

<style lang="stylus" scoped>

.PageTitle

  display: flex
  flex-direction: column
  align-items: stretch
  justify-content: center
  pointer-events none
  text-align center
  color white;
  pointer-events none
  transform translate3d( 0, 0, 0)

  &_baseline
    color white
    margin 0px auto 30px auto

    @media $mq_m
      margin 0px auto 4vw auto

  &_baselineLabel
    font-size: 12px;
    letter-spacing: .4em
    text-transform uppercase

    @media $mq_m
      font-size: 14px;

  &_baselineSep
    background-color white
    width 100px
    height 1px
    margin 10px auto
    transform translate3d( 0, 0, 0)

    @media $mq_m
      height 2px
      width 250px
      margin 15px auto

  &_title
    font-size: font_size = 5.5vw
    line-height: font_size
    padding 0 20px
    height 7.5vw

    &.v-enter,
    &.v-leave-to
      opacity 0

    &.v-enter-active
      transition: opacity .8s .2s $ease
      // transform translate3d( 0, 50px, 0 )

    &.v-leave-active
      transition: opacity 0.5s $ease
      position absolute
      width 100%
      box-sizing border-box
      // transform translate3d( 0, -50px, 0 )

.fade-enter,
.fade-leave-to
  opacity 0

.fade-enter-active
  transition: opacity .8s .2s $ease
  // transform translate3d( 0, 50px, 0 )

.fade-leave-active
  transition: opacity 0.5s $ease
  position absolute
  width 100%

// .title-enter,
// .title-leave-to
//   opacity 0

// .title-enter-active
//   transition: opacity 1.3s $ease 1.2s

// .title-leave-active
//   transition: opacity 0.8s $ease

// -----------------------------------
// Cas Spéciaux
// -----------------------------------
.TourCover

  .PageTitle
    &_title
      color $beige

.CollectionCover

  .PageTitle
    &_title
      font-size: font_size = 5vw
      line-height: font_size
      max-width: 65%
      margin 0 auto

.Home
  .PageTitle
    position relative
    transform translate(0, -15%) // better vertical alignement

    // On place la baseline en absolu pour que le container
    // center le composant par rapport au titre
    &_baseline
      position absolute
      top -35px
      left 50%
      transform translate(-50%, -100%)

</style>
